module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Bold-5e9f6556d3c0bf6230f096babff09921.ttf";